import { observable, action, makeObservable } from 'mobx';
import { BaseQueryStore } from 'core/stores';
import { LookupService } from 'common/data';
import { isSome } from 'core/utils';
import { lookupRouteName } from 'common/constants';
import _ from 'lodash';

class LookupStore extends BaseQueryStore {
	@observable item = null;
	getLookupService(name) {
		const key = 'lookupService' + _.capitalize(name);
		if (!isSome(this[key])) {
			this[key] = new LookupService(this.rootStore.app.baasic.apiClient, name);
		}
		return this[key];
	}

	constructor(rootStore) {
		super();
		makeObservable(this);
		this.rootStore = rootStore;
	}

	@action async find(filter, lookupServiceName) {
		const response = await this.getLookupService(lookupServiceName).find(filter);
		if (filter && filter.search) {
			response.data.searchQuery = filter.search;
		}
		this.response = response.data;
		return response;
	}

	@action async getLookup(lookupServiceName, options = null) {
		const lookup = await this.getLookupService(lookupServiceName).get(
			this.rootStore.routerStore.routerState.queryParams.editId,
			options
		);
		this.item = lookup.data;
	}

	@action async updateLookup(item, lookupServiceName, sourceOfChange) {
		if (!item.abrv) {
			if (lookupServiceName !== lookupRouteName.productCountry) {
				item.abrv = encodeURIComponent(item.name).toLowerCase();
			} else {
				item.abrv = item.countryCode;
			}
		}
		await this.getLookupService(lookupServiceName).update(item, sourceOfChange);
	}

	@action async createLookup(item, lookupServiceName, sourceOfChange) {
		if (!item.abrv) {
			if (lookupServiceName !== lookupRouteName.productCountry) {
				item.abrv = encodeURIComponent(item.name).toLowerCase();
			} else {
				item.abrv = item.countryCode;
			}
		}
		const lookup = await this.getLookupService(lookupServiceName).create(item, sourceOfChange);
		this.item = lookup.data;
		return lookup.data;
	}

	@action async createLookups(items, lookupServiceName, sourceOfChange) {
		await this.getLookupService(lookupServiceName).createBatch(items, sourceOfChange);
	}

	@action async deleteLookup(item, lookupServiceName) {
		await this.getLookupService(lookupServiceName).delete(item);
	}
}

export default LookupStore;



// WEBPACK FOOTER //
// ./src/modules/lookup/stores/LookupStore.js